import { render } from "./Basics.vue?vue&type=template&id=3fb077f4&scoped=true&ts=true"
import script from "./Basics.vue?vue&type=script&lang=ts"
export * from "./Basics.vue?vue&type=script&lang=ts"

import "./Basics.vue?vue&type=style&index=0&id=3fb077f4&lang=scss&scoped=true"
import "./Basics.vue?vue&type=style&index=1&id=3fb077f4&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb077f4"]])

export default __exports__